import { Injectable } from '@angular/core';
import { BaseService } from '../../../core/service/base.service';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable } from 'rxjs/index';
import { PageData } from '../../../core/bean/page-data';
//
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})

export class JyExtendService extends BaseService {
  HEADER_NAME_TOTALCOUNT = 'X-Total-Count';
  private typeUrl = 'api/workflowBase/types';  // 全部类型
  private url = 'api/workflowRequest/getPending';        //待办流程
  private backUrl = '';
  private currentUrl = 'api/workflowRequest/request';    //当前流程
  private commit = 'api/workflowRequest/commit';         //流程提交
  private newWork = 'api/workflowRequest/startWorkflow';  //新建流程详情
  private historyTask = 'api/workflowRequest/historyTask'; //退回节点列表
  private RollbackAll = 'api/workflowRequest/requestRollbackAll'; //退回到指定节点
  private Already = 'api/workflowRequest/getAlready';     //已办流程
  private save = 'api/workflowRequest/save';              //新建保存
  private haveUser = 'api/actUser/users';
  private typeTree = 'api/workflowRequest/tree';    //获取流程树
  private ApproveInfo = 'api/approvelog/getAlreadyRequest';//已办流程修改
  constructor(http: HttpClient) {
    super(http);
  }

  getTree() {
    return this.typeTree;
  }

  getTransfer() {
    return 'api/workflowRequest/transfer';
  }

  forward() {
    return 'api/workflowRequest/forward';
  }

  getHaveUser() {
    return this.haveUser;
  }

  postSave() {
    return this.save;
  }

  getAlread(): string {
    return this.Already;
  }
  getApproveInfo(): string {
    return this.ApproveInfo;
  }
  getUrl(): string {
    return this.url;
  }

  getTypeUrl(): string {
    return this.typeUrl;
  }

  getCurrentUrl() {
    return this.currentUrl;
  }

  getHistoryTask() {
    return this.historyTask;
  }

  getRollbackAll() {
    return this.RollbackAll;
  }

  getNew() {
    return this.newWork;
  }

  postNewData() {
    return this.commit;
  }

//全部流程页面
  getUserWorkflow(): Observable<any> {
    const url = `${this.getTypeUrl()}`;
    return this.http.get<any>(url).pipe(
      catchError(this.handleError<any>(`get top menu`)),
    );
  }

  //全部流程树页面
  getTypeTree(obj: object) {
    let params = new HttpParams();
    var data = '';
    for (var key in obj) {
      data += '&' + key + '=' + obj[key];
    }
    data = data.slice(1);
    data = '?' + data;
    this.backUrl = data;

    return new Observable((observable) => {
      this.http.get(`${this.getTree()}/${this.backUrl}`, {
        observe: 'response',//完整数据返回，包括抬头
        params,
      }).pipe(
        tap(() => this.log('query object')),
        catchError(this.handleError('get any', [])),
      ).subscribe((httpResponse: HttpResponse<any>) => {
        let totalCount = httpResponse.headers.get(this.HEADER_NAME_TOTALCOUNT);
        let data = httpResponse.body;
        let pageData = new PageData(Number.parseInt(totalCount), data);
        observable.next(pageData);
      }, error => {
        observable.error(error);
      }, () => {
        observable.complete();
      });
    });
  }

//已办用户名
  getUser(): Observable<any> {
    const url = `${this.getHaveUser()}`;
    return this.http.get<any>(url).pipe(
      catchError(this.handleError<any>(`get top menu`)),
    );
  }

//全部未办流程
  GetQuery(object: any): Observable<any> {
    return this.http.post<any>(this.getUrl(), object, httpOptions).pipe(
      tap((object: any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany')),
    );
  }

  /** 获取当前用户 */
  getUsers(): Observable<any> {
    return this.http.get('api/user/current',
      {
        headers: httpOptions.headers,
        observe: 'response',//完整数据返回，包括抬头
      },
    ).pipe(
      tap(() => this.log('query object')),
      catchError(this.handleError('get any', [])),
    );
  }


//  请求当前流程

  current(params):Observable<any> {
    return this.http.get(this.getCurrentUrl(),
      {
        headers: httpOptions.headers,
        params: params
      }
    ).pipe(
      tap(() => this.log('getModule')),
      catchError(this.handleError('getModule'))
    );
  }

  //...
  getNewChoice(obj: object) {
    let params = new HttpParams();
    let data = '';
    for (var key in obj) {
      data += '&' + key + '=' + obj[key];
    }
    data = data.slice(1);
    data = '?' + data;
    this.backUrl = data;
    return new Observable((observable) => {
      this.http.get(`${this.getNew()}/${this.backUrl}`, {
        observe: 'response',//完整数据返回，包括抬头
        params,
      }).pipe(
        tap(() => this.log('query object')),
        catchError(this.handleError('get any', [])),
      ).subscribe((httpResponse: HttpResponse<any>) => {
        let totalCount = httpResponse.headers.get(this.HEADER_NAME_TOTALCOUNT);
        let data = httpResponse.body;
        let pageData = new PageData(Number.parseInt(totalCount), data);
        observable.next(pageData);
      }, error => {
        observable.error(error);
      }, () => {
        observable.complete();
      });
    });
  }

//获取退回节点列表
  HistoryTask(obj: object) {
    let params = new HttpParams();
    let data = '';
    for (var key in obj) {
      data += '&' + key + '=' + obj[key];
    }
    data = data.slice(1);
    data = '?' + data;
    this.backUrl = data;
    return new Observable((observable) => {
      this.http.get(`${this.getHistoryTask()}/${this.backUrl}`, {
        observe: 'response',//完整数据返回，包括抬头
        params,
      }).pipe(
        tap(() => this.log('query object')),
        catchError(this.handleError('get any', [])),
      ).subscribe((httpResponse: HttpResponse<any>) => {
        let totalCount = httpResponse.headers.get(this.HEADER_NAME_TOTALCOUNT);
        let data = httpResponse.body;
        let pageData = new PageData(Number.parseInt(totalCount), data);
        observable.next(pageData);
      }, error => {
        observable.error(error);
      }, () => {
        observable.complete();
      });
    });
  }

  //退回到指定节点
  getRollback(object: any): Observable<any> {
    return this.http.post<any>(this.getRollbackAll(), object, httpOptions).pipe(
      tap((object: any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany')),
    );
  }

//  请求所有已办
  getHavedone(object: any): Observable<any> {
    return this.http.post<any>(this.getAlread(), object, httpOptions).pipe(
      tap((object: any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany')),
    );
  }
// 请求已办流程
  getApprovelog(object: any): Observable<any> {
    return this.http.post<any>(this.getApproveInfo(), object, httpOptions).pipe(
      tap((object: any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany')),
    );
  }
  //搜索已办
  haveDoneSearch(object: any): Observable<any> {
    return this.http.post<any>(this.getAlread(), object, httpOptions).pipe(
      tap((object: any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany')),
    );
  }

//  搜索待办
  searchBackLog(object: any): Observable<any> {
    return this.http.post<any>(this.getUrl(), object, httpOptions).pipe(
      tap((object: any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany')),
    );
  }

//  发送待办消息
  sendBackLog(): Observable<any> {
    return this.http.post<any>('api/workflowRequest/getPendingMsg', {}, httpOptions).pipe(
      tap((object: any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany')),
    );
  }

//提交新建流程数据
  addNewFlowData(object: any): Observable<any> {
    return this.http.post<any>(this.postNewData(), object, httpOptions).pipe(
      tap((object: any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany')),
    );
  }

  //保存新建流程数据
  saveNewFlowData(object: any): Observable<any> {
    return this.http.post<any>(this.postSave(), object, httpOptions).pipe(
      tap((object: any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany')),
    );
  }

//删除

  deleteBatchMethods(id: any[]): Observable<any> {
    let params = new HttpParams();
    for (let item of id) {
      params = params.append('requestId', item);
    }
    return this.http.delete<any>('api/workflowRequest/delete', {
      headers: httpOptions.headers,
      params: params,
    }).pipe(
      tap(_ => this.log(`deleted object list id=${id}`)),
      catchError(this.handleError<any>('delet object list')),
    );
  }

//转办
  Transfer(obj: object) {
    let params = new HttpParams();
    let data = '';
    for (var key in obj) {
      data += '&' + key + '=' + obj[key];
    }
    data = data.slice(1);
    data = '?' + data;
    this.backUrl = data;
    return new Observable((observable) => {
      this.http.get(`${this.getTransfer()}/${this.backUrl}`, {
        observe: 'response',//完整数据返回，包括抬头
        params,
      }).pipe(
        tap(() => this.log('query object')),
        catchError(this.handleError('get any', [])),
      ).subscribe((httpResponse: HttpResponse<any>) => {
        let totalCount = httpResponse.headers.get(this.HEADER_NAME_TOTALCOUNT);
        let data = httpResponse.body;
        let pageData = new PageData(Number.parseInt(totalCount), data);
        observable.next(pageData);
      }, error => {
        observable.error(error);
      }, () => {
        observable.complete();
      });
    });
  }

//转发
  getForward(obj: object) {
    let params = new HttpParams();
    let data = '';
    for (var key in obj) {
      data += '&' + key + '=' + obj[key];
    }
    data = data.slice(1);
    data = '?' + data;
    this.backUrl = data;
    return new Observable((observable) => {
      this.http.get(`${this.forward()}/${this.backUrl}`, {
        observe: 'response',//完整数据返回，包括抬头
        params,
      }).pipe(
        tap(() => this.log('query object')),
        catchError(this.handleError('get any', [])),
      ).subscribe((httpResponse: HttpResponse<any>) => {
        let totalCount = httpResponse.headers.get(this.HEADER_NAME_TOTALCOUNT);
        let data = httpResponse.body;
        let pageData = new PageData(Number.parseInt(totalCount), data);
        observable.next(pageData);
      }, error => {
        observable.error(error);
      }, () => {
        observable.complete();
      });
    });
  }

  forwarding(obj: object) {
    let params = new HttpParams();
    let data = '';
    for (var key in obj) {
      data += '&' + key + '=' + obj[key];
    }
    data = data.slice(1);
    data = '?' + data;
    this.backUrl = data;
    return new Observable((observable) => {
      this.http.get(`api/workflowRequest/requestForward${this.backUrl}`, {
        observe: 'response',//完整数据返回，包括抬头
        params,
      }).pipe(
        tap(() => this.log('query object')),
        catchError(this.handleError('get any', [])),
      ).subscribe((httpResponse: HttpResponse<any>) => {
        let totalCount = httpResponse.headers.get(this.HEADER_NAME_TOTALCOUNT);
        let data = httpResponse.body;
        let pageData = new PageData(Number.parseInt(totalCount), data);
        observable.next(pageData);
      }, error => {
        observable.error(error);
      }, () => {
        observable.complete();
      });
    });
  }

  validationFalse(params):Observable<any> {
    return this.http.get('api/workflowRequest/requestBusiness',
      {
        headers: httpOptions.headers,
        params: params
      }
    ).pipe(
      tap(() => this.log('getModule')),
      catchError(this.handleError('getModule'))
    );
  }

  validation(params):Observable<any> {
    return this.http.get('api/workflowRequest/requestView',
      {
        headers: httpOptions.headers,
        params: params
      }
    ).pipe(
      tap(() => this.log('getModule')),
      catchError(this.handleError('getModule'))
    );
  }
  findTaskResult(params):Observable<any> {
    return this.http.get('api/sup-ass-flow/findTaskResult',
      {
        headers: httpOptions.headers,
        params: params
      }
    ).pipe(
      tap(() => this.log('getModule')),
      catchError(this.handleError('getModule'))
    );
  }


}
